import * as envSsm from 'env-ssm';
import React from 'react';
import PropTypes from 'prop-types';

import IconAmazonBanner from 'icons/assocbutt_or_buy.png';

const CrossLoggerPlugin = require('cross-logger-plugin');

const logger = new CrossLoggerPlugin(
  `App:${__filename.replace(__dirname, '')}`,
);

// ----------------------------------
// Component
// ----------------------------------
export default class Home extends React.Component {
  static propTypes = {
    initializeData: PropTypes.element.isRequired,
  };

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        className="w-100"
        style={{ backgroundColor: '#00B900', color: 'white' }}
      >
        <div className="h-100 container">
          <p
            className="text-white text-center"
            style={{
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            今すぐ無料で始められる新世代オーダーシステム「スマートオーダークイック」
          </p>
          <p
            className="text-white text-center"
            style={{
              fontSize: '1.5em',
              fontWeight: 'bold',
            }}
          >
            無料・端末不要・契約不要・工事不要！
            <br />
            アプリをインストールするだけでいますぐ導入できる無料のオーダーシステム
          </p>

          <hr className="white-hr" />
        </div>

        {/*
        // lg
        */}
        <div className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
          <h1
            className="text-white text-center w-100"
            style={{
              fontSize: '2.5em',
              fontWeight: 'bold',
            }}
          >
            スマートオーダークイック
          </h1>
        </div>

        {/*
        // md
        */}
        <div className="d-block d-sm-none d-md-none d-lg-none d-xl-none">
          <h1
            className="text-white text-center w-100"
            style={{
              fontSize: '8.3vw',
              fontWeight: 'bold',
            }}
          >
            スマートオーダークイック
          </h1>
        </div>

        <div className="h-100 container">
          <hr className="white-hr" />

          <div className="row d-flex align-items-center">
            <div className="col-sm-6 col-12">
              <p
                className="text-white text-center"
                style={{
                  fontSize: '1.5em',
                  fontWeight: 'bold',
                }}
              >
                スマートオーダークイックはスマホ一台で導入できる
                無料のオーダーシステムです
                <br />
                <br />
                面倒な契約や工事は一切不要！
                <br />
                <br />
                アプリをインストールするだけで
                今すぐオーダーシステムを導入できます！
              </p>

              <div className="text-center disabled">
                <a
                  href="https://apps.apple.com/jp/app/%E3%82%B9%E3%83%9E%E3%83%BC%E3%83%88%E3%82%AA%E3%83%BC%E3%83%80%E3%83%BC%E3%82%AF%E3%82%A4%E3%83%83%E3%82%AF/id1537224128?itsct=apps_box&itscg=30200"
                  target="_blank"
                >
                  <img
                    src="/img/app-store-button.png"
                    className="w-100"
                    style={{ maxWidth: '200px' }}
                  />
                </a>
                <br />
                <a
                  href="https://play.google.com/store/apps/details?id=com.smartorderquickapp"
                  target="_blank"
                >
                  <img
                    src="/img/google-play-button.png"
                    className="w-100"
                    style={{ maxWidth: '200px' }}
                  />
                </a>
              </div>
            </div>
            <div className="col-sm-6 col-12">
              <div className="row">
                <div className="col-sm-6 col-12 mt-2">
                  <img src="/img/store-image-1.png" className="w-100" />
                </div>
                <div className="col-sm-6 col-12 mt-2">
                  <img src="/img/store-image-2.png" className="w-100" />
                </div>
              </div>
            </div>
          </div>

          <hr className="white-hr" />

          <h3
            className="text-white text-center"
            style={{
              fontSize: '2.5em',
              fontWeight: 'bold',
            }}
          >
            使い方は簡単！
          </h3>

          <div className="row">
            <div className="col-sm-4 col-12 mt-2">
              <p
                className="text-white text-center"
                style={{
                  fontSize: '1.2em',
                  fontWeight: 'bold',
                }}
              >
                ①店舗側のスマホで
                <br />
                QRコードを印刷もしくは表示
              </p>
            </div>
            <div className="col-sm-4 col-12 mt-2">
              <p
                className="text-white text-center"
                style={{
                  fontSize: '1.2em',
                  fontWeight: 'bold',
                }}
              >
                ②お客様のスマホで
                <br />
                QRコードをスキャン
              </p>
            </div>
            <div className="col-sm-4 col-12 mt-2">
              <p
                className="text-white text-center"
                style={{
                  fontSize: '1.2em',
                  fontWeight: 'bold',
                }}
              >
                ③お客様のスマホにメニューが表示されて
                <br />
                オーダー画面に！
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <img src="/img/demo-1.png" className="w-100" />
              <p className="float-right">→</p>
            </div>
            <div className="col-4">
              <img src="/img/demo-2.png" className="w-100" />
              <p className="float-right">→</p>
            </div>
            <div className="col-4">
              <img src="/img/demo-3.png" className="w-100" />
            </div>
          </div>

          <hr className="white-hr" />
          <h3 className="text-white text-center">Q.なぜ無料なの?</h3>
          <div className="mx-auto max-content-width card bg-white">
            <p className="card-body text-body text-left">
              スマートオーダークイックではお客様のオーダー画面に広告を掲載することで収益を得ています。
              <br />
              月額プラン(有料)に加入して頂くとお客様のオーダー画面に広告が出なくなり、
              <br />
              スマートオーダークイックの全ての機能がご利用頂けます。
              <br />
              月額プランもスマホから直接課金されるので契約は不要です。
              <br />
              ※有料プランは現在実装中です
            </p>
          </div>

          <hr className="white-hr" />
          <h3 className="text-white text-center">Q.オーダーは印刷できる?</h3>
          <div className="mx-auto max-content-width card bg-white">
            <p className="card-body text-body text-left">
              はい。オーダーは自動的に印刷されます。
              <br />
              スマートオーダークイックは対応したモバイルプリンターを接続する前提で設計されています。
              <br />
              モバイルプリンターが無くてもオーダーシステムとしてご利用できます。
              <br />
              対応モバイルプリンタについて
            </p>
          </div>

          <hr className="white-hr" />
          <h3 className="text-white text-center">
            Q.プリンターをキッチンとホールに置ける?
          </h3>
          <div className="mx-auto max-content-width card bg-white">
            <p className="card-body text-body text-left">
              はい。追加でスマートオーダークイックをインストールしたスマホがあれば複数の場所にプリンターを設置することができます。
              <br />
              スマートオーダークイックの入ったスマホはクラウドで自動連帯します。
              <br />
              キッチンのオーダーはキッチンに置いたスマホでのみ印刷、ホールのオーダーはホールに置いたスマホでのみ印刷、と設定することが可能です。
              <br />
              印刷グループは自由に設定できるので「受付」「倉庫」「事務所」など活用方法は無限です。
              <br />
              クラウド連帯なので場所を問いません。世界中どこでもスマートオーダークイックは連帯稼働します。
              <br />
              ※インターネット接続状況により安定しない場合があります
            </p>
          </div>

          <hr className="white-hr" />
          <h3 className="text-white text-center">Q.なぜ端末が不要？</h3>
          <div className="mx-auto max-content-width card bg-white">
            <p className="card-body text-body text-left">
              お客様のスマートフォンから直接オーダーできるので端末を用意する必要はありません。
              <br />
              感染症対策にも効果的です。
              <br />
              お使いのスマートフォンや昔使っていたスマートフォン一台あればオーダーシステムを始められます。
              <br />
              モバイルプリンターがあればQRコードとオーダーが印刷されより便利にご利用頂けます。
            </p>
          </div>

          <hr className="white-hr" />
          <h3 className="text-white text-center">Q.設定は複雑？</h3>
          <div className="mx-auto max-content-width card bg-white">
            <p className="card-body text-body text-left">
              設定は簡単です。客席と商品名だけ登録すればすぐに使い始めることができます。
              <br />
              詳細な設定も可能です。
              {/* アプリをインストールしてアカウントを作成すると使い方ガイドと初期設定の客席とメニューが用意されています。
              <br />
              メニューの設定もアプリから簡単に操作できます。 */}
            </p>
          </div>

          <hr className="white-hr" />
          <h3 className="text-white text-center">Q.写真は掲載できる？</h3>
          <div className="mx-auto max-content-width card bg-white">
            <p className="card-body text-body text-left">
              もちろん写真を掲載できます。
              <br />
              メニューを作成したらスマホで写真を撮ってそのまま登録できます。
              <br />
              簡単に設定できるので日替わりメニューなどにも対応できます。
            </p>
          </div>

          <hr className="white-hr" />
          <h3 className="text-white text-center">
            Q.飲食店以外でも利用できる？
          </h3>
          <div className="mx-auto max-content-width card bg-white">
            <p className="card-body text-body text-left">
              はい。ご利用できます。
              <br />
              スマートオーダークイックはメニュー設定と客席設定により、銀行、ホテル、イベント、飲食店、介護施設、ジム等様々な施設でご利用頂けます。
            </p>
          </div>

          <hr className="white-hr" />
          <h3 className="text-white text-center">
            Q.スマートオーダークイック対応モバイルプリンター
          </h3>
          <div className="mx-auto max-content-width card bg-white">
            <p
              className="card-body text-body text-left"
              style={{ color: 'red' }}
            >
              ※ここに掲載されているモバイルプリンタは動作を保証するものではありません
              <br />
              ※購入前にレンタルサービス等を利用して数日動作確認した後にご購入下さい
            </p>
          </div>
          <div className="mt-2" />
          <div className="mx-auto max-content-width card bg-white">
            <p className="card-body text-body text-center">
              <span>
                <span style={{ color: 'green' }}>
                  <strong>オススメ！</strong>
                </span>
                <br />
                Bluetooth3.0対応モバイルプリンター
              </span>
              <br />

              <a href="https://amzn.to/3nXJlMK" target="_blank">
                セイコーインスツル&nbsp;MP-B20
                <br />
                <img
                  src="https://images-na.ssl-images-amazon.com/images/I/51GY87bnJ4L._AC_SL1001_.jpg"
                  width={200}
                  alt="amazon"
                />
                <br />
                <img src={IconAmazonBanner} alt="amazon" />
              </a>
            </p>
          </div>
          <div className="mt-2" />
          <div className="mx-auto max-content-width card bg-white">
            <p className="card-body text-body text-center">
              <span>
                <span style={{ color: 'green' }}>
                  <strong>オススメ！</strong>
                </span>
                <br />
                Bluetooth3.0対応モバイルプリンター
              </span>
              <br />
              <a href="https://amzn.to/2J7ARDN" target="_blank">
                スター精密&nbsp;SM-S210i
                <br />
                <img
                  src="https://images-na.ssl-images-amazon.com/images/I/61rGlrt-ANL._AC_SL1280_.jpg"
                  width={200}
                  alt="amazon"
                />
                <br />
                <img src={IconAmazonBanner} alt="amazon" />
              </a>
            </p>
          </div>
          <div className="mt-2" />
          <div className="mx-auto max-content-width card bg-white">
            <p className="card-body text-body text-center">
              <span>BLE(Bluetooth4.0) ESCPOS互換モバイルプリンター</span>
              <br />
              <span style={{ color: 'blue' }}>
                ※スマホとの相性により不安定な動作をする場合があります。
                <br />
                その場合はBluetooth3.0対応モバイルプリンターをご利用下さい。
                <br />
              </span>
              <br />
              <br />
              <br />
              <br />
              <a href="https://amzn.to/3nVUfms" target="_blank">
                Nyear NP100 58mm
                <br />
                <img
                  src="https://images-na.ssl-images-amazon.com/images/I/71SiKvlf6WL._AC_SL1500_.jpg"
                  width={200}
                  alt="amazon"
                />
                <br />
                <img src={IconAmazonBanner} alt="amazon" />
              </a>
              <br />
              <br />
              <br />
              <a href="https://amzn.to/3m3S7sf" target="_blank">
                Symcode MJ-5802 58mm
                <br />
                <img
                  src="https://images-na.ssl-images-amazon.com/images/I/61M964s03XL._AC_SL1000_.jpg"
                  width={200}
                  alt="amazon"
                />
                <br />
                <img src={IconAmazonBanner} alt="amazon" />
              </a>
              <br />
              <br />
              <br />
              <a href="https://amzn.to/39fzJt0" target="_blank">
                Richer-R 58mm Thermal Printer
                <br />
                <img
                  src="https://images-na.ssl-images-amazon.com/images/I/61101CwPosL._AC_SL1001_.jpg"
                  width={200}
                  alt="amazon"
                />
                <br />
                <img src={IconAmazonBanner} alt="amazon" />
              </a>
            </p>
          </div>
        </div>
        <hr className="white-hr" />
        <footer className="mt-2 container">
          <div>
            <p className="text-center">
              <a className="text-light" href="/privacy">
                プライバシーポリシー・利用規約
              </a>
            </p>
          </div>
          <div>
            <p className="text-center">
              運営会社
              <br />
              株式会社ウィステリア
              <br />
              本社所在地 : 山口県山口市
              <br />
              お問い合わせ : so-series@wisteria-office.jp
            </p>
          </div>
        </footer>
      </div>
    );
  }
}
